<template>
  <div class="pl-3 pr-3">
    <custom-callout
      v-for="(item, idx) of alldocuments"
      id="customCalloutUploadDownloadDocumentsPdf"
      :key="idx"
      class-main="mt-3"
      :has-border="true"
      :has-gradient="false"
      :has-toggle="false"
    >
      <div class="ml-md-3 pl-md-2 mr-md-3 mt-md-2 mb-md-2">
        <div class="row mr-md-0 ml-n0 ml-md-n4 ml-0">
          <div class="col-md-4 col-sm-12">
            <span class="data-title d-block border-mobile">
              Tipo de Documento:
            </span>
            <span class="font-16 color-black">
              {{ item.documentTypeName }}
            </span>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="d-flex justify-content-center">
              <div class="container-document">
                <span class="data-title d-block border-mobile ml-md-5">
                  Archivo:
                </span>
                <span class="font-16 color-black ml-md-5 align-file">
                  {{ item.documentName }}
                </span>
              </div>
            </div>
          </div>
          <div
            class="
              col-md-4 col-sm-12
              d-flex
              justify-content-end
              align-items-start
            "
          >
            <action-button
              id="actionBtnDownloadDocumentsPdf"
              class="btn-action-size"
              i="fas fa-file-download"
              variant="success"
              @click="downloadDocument(item.documentId)"
            />
          </div>
        </div>
      </div>
    </custom-callout>
    <div>
      <pagination
        v-if="pagination.totalItemCount > 5"
        class="mb-0"
        :data="pagination"
        show-text
        @page-size-change="changePageSize"
        @pagination-go-page="goToPageHandler"
      />
    </div>
    <validation-observer ref="endPeriodDocumentForm" v-slot="{}" tag="form">
      <div class="row mt-3 mb-3 pl-2">
        <div class="col-md-3 col-sm-12">
          <span class="data-title d-block border-mobile mb-1">
            Tipo de Documento:
          </span>
          <validation-provider
            v-slot="{ errors }"
            name="documentType"
            rules="required"
          >
            <custom-drop-down
              v-model="documentTypeSelected"
              custom-error-msg="El tipo de documento es requerido."
              :disabled="false"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="docTypes"
            />
          </validation-provider>
        </div>
        <div class="col-md-3 col-sm-12 file-custom">
          <span class="data-title d-block border-mobile mb-1">Archivo:</span>
          <validation-provider
            v-slot="{ errors }"
            name="fileUpload"
            rules="required"
          >
            <custom-file-input
              ref="proRemfileUpload"
              :accept="'.pdf'"
              accept-terms-modal-title="Certificación"
              accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
              accept-terms-title="Acepto los términos y responsabilidades"
              accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
              allow-accept-terms
              :custom-error-msg="'El documento es requerido.'"
              display-style="normal"
              :error="errors[0]"
              label-position="left"
              :on-download="onDownloadFile"
              required
              :value="document.file"
              @input="onChangeFile"
            />
          </validation-provider>
        </div>
        <div
          class="col-md-6 col-sm-12 align-self-end d-flex justify-content-end"
          style="height: 39px"
        >
          <action-button
            id="certification-cancel-btn"
            class="float-right"
            i="fas fa-times-circle p-2"
            text="Cancelar"
            variant="outline-danger pr-3 mr-2 pt-1"
            @click="openCloseTabs"
          />

          <action-button
            id="certification-save-btn"
            i="fas fa-save fa-lg p-2 "
            text="Guardar"
            variant="success pr-3 mr-2 pt-1"
            @click="onSaveDocument"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import CustomFileInput from 'CustomFileInput';
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import objectToFormData from 'object-to-formdata';
import {
  getEndtermDocumentTypes,
  saveDocument,
  getEndtermDocumentSaved,
  deleteBDocument,
} from '@/services/provider/end-term.api';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import Pagination from 'pagination';
import { downloadDocumentByAttachmentId } from '@/services/common/document.api';

//constants
import rpContractDocumentTypes from '@/utils/constants/rpContractDocumentTypes.js';

export default {
  name: 'DocumentsEndPeriod',
  mixins: [alertMixin],
  components: {
    CustomFileInput,
    CustomCallout,
    Pagination,
    CustomDropDown,
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    academicYear: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      document: {
        filename: null,
        contractDocumentTypeId: null,
        academicYearId: null,
        contractId: null,
        file: null,
      },
      documentsTypes: [],
      alldocuments: [],
      documentTypeSelected: null,
      pagination: {
        pageIndex: 1,
        pageSize: 5,
        totalItemCount: 0,
        showPageSizeOptions: false,
      },
    };
  },
  async mounted() {
    await this.getDocumentsFromApi();
    await this.getDataFromApi();
  },
  computed: {
    docTypes() {
      return (this.documentsTypes || []).filter(
        (dt) =>
          !(this.alldocuments || [])?.some(
            (d) =>
              d.documentTypeId == dt.id &&
              dt.id != rpContractDocumentTypes.Others
          )
      );
    },
  },
  methods: {
    async getDocumentsFromApi() {
      await getEndtermDocumentTypes().then((data) => {
        this.documentsTypes = data.data;
        if (this.documentsTypes.length > 0) {
          this.documentsTypes = this.documentsTypes.filter(
            (dt) =>
              dt.id != rpContractDocumentTypes.AttendanceSheet &&
              dt.id !=
                rpContractDocumentTypes.PrBackgroundCheckProgramCertification &&
              dt.id != rpContractDocumentTypes.SinglePermit &&
              dt.id != rpContractDocumentTypes.PrBackgroundCheck300
          );
        }
      });
    },
    async getDataFromApi() {
      let payload = {
        contractId: this.data.contractId,
        visitSummaryId: this.data.visitSummaryId,
        pageIndex: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
      };
      const { data } = await getEndtermDocumentSaved(payload);
      this.alldocuments = data.data;
      this.pagination = {
        ...this.pagination,
        count: data.count,
        currentPage: data.currentPage,
        pageCount: data.pageCount,
        totalItemCount: data.totalItemCount,
      };
    },
    onChangeFile(file) {
      if (file) {
        this.document.filename = file.name;
        this.document.file = file;
      } else {
        this.document.file = null;
        this.document.filename = null;
      }
    },
    openCloseTabs() {
      this.$emit('close-tabs');
    },
    async deleteDocument(id) {
      await deleteBDocument(id);
      this.getDataFromApi();
    },
    onDownloadFile() {},
    async downloadDocument(id) {
      downloadDocumentByAttachmentId(id);
    },
    async changePageSize(size) {
      this.pagination.pageSize = size;
      await this.getDataFromApi();
    },
    async goToPageHandler(page) {
      this.pagination.pageIndex = page;
      await this.getDataFromApi();
    },
    async onSaveDocument() {
      const isValid = await this.$refs.endPeriodDocumentForm.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      } else {
        this.document.academicYearId = this.academicYear.id;
        this.document.contractId = this.data.contractId;
        this.document.contractDocumentTypeId = this.documentTypeSelected.id;
        const documentTypeId = this.documentTypeSelected.id;
        const payload = objectToFormData(this.document, {
          indices: true,
          nullsAsUndefineds: true,
        });
        await saveDocument(payload).then(async () => {
          this.document.file = null;
          this.document.filename = null;
          this.documentTypeSelected = null;
          this.ShowToast(
            'Proceso exitoso.',
            'El documento ha sido añadido existosamente.',
            'success'
          );
          this.$emit('on-save-document', documentTypeId);
          this.$refs.proRemfileUpload.removeFile();
          await this.$refs.endPeriodDocumentForm.reset();
          await this.getDocumentsFromApi();
          await this.getDataFromApi();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container-info {
  position: relative;
  top: -15px;
}
.orange-icon {
  color: hsl(9, 100%, 67%);
}
.container-document {
  width: 200px;
}
.btn-action-size {
  width: 38px;
  height: 38px;
}
</style>
